import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import "../../css/classes/annualView.css";

  // const expenseGrowthData = {
  //   categories: [
  //     "Mar 2023",
  //     "Apr 2023",
  //     "May 2023",
  //     "Jun 2023",
  //     "Jul 2023",
  //     "Aug 2023",
  //     "Sep 2023",
  //     "Oct 2023",
  //     "Nov 2023",
  //     "Dec 2023",
  //     "Jan 2024",
  //     "Feb 2024",
  //   ],
  //   growth: [-5, -7, 0, 13, -11, 0, -10, 1, 3, -14, 1, 0],
  // };



function AnnualHeadStats({ remainingSummary, apiData }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [animatedValues, setAnimatedValues] = useState({
    availableBalance: 0,
    totalIncome: 0,
    totalSpending: 0,
    spendingRate: 0,
    savingRate: 0,
  });

  useEffect(() => {
    setIsLoaded(true);
    const timer = setTimeout(() => {
      setAnimatedValues({
        availableBalance: apiData?.api1?.budgetLeft?.toFixed(2) ?? 0,
        totalIncome: apiData?.api1?.totalBudget?.toFixed(2) ?? 0,
        totalSpending: apiData?.api1?.totalExpense?.toFixed(2) ?? 0,
        spendingRate: apiData?.api1?.spendingPercentage?.toFixed(2) ?? 0,
        savingRate: apiData?.api1?.savingPercentage?.toFixed(2) ?? 0,
      });
    }, 500);

    return () => clearTimeout(timer);
  }, [apiData?.api1]);

  const expenseGrowthData = {
  categories: apiData?.api3?.map(item => item.month) || [],
  growth: apiData?.api3?.map(item => Number(item.usagePercentage)) || [],
};

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
    })
      .format(amount)
      .replace("₹", "₹ ");
  };

    const growthChartSeries = [
    {
      name: "Growth",
      data: expenseGrowthData.growth,
    },
  ];

  const growthChartOptions = {
    chart: {
      type: "line",
      height: 350,
      toolbar: { show: false },
      background: "transparent",
    },
    stroke: {
      width: 3,
      curve: "smooth",
    },
    colors: ["#A855F7"],
    xaxis: {
      categories: expenseGrowthData.categories,
      labels: {
        style: {
          colors: "#6B7280",
          fontSize: "11px",
        },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return `${val}%`;
        },
        style: {
          colors: "#6B7280",
          fontSize: "11px",
        },
      },
    },
    grid: {
      borderColor: "#F3F4F6",
      strokeDashArray: 3,
    },
    markers: {
      size: 6,
      colors: ["#A855F7"],
      strokeColors: "#fff",
      strokeWidth: 2,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return `${val}%`;
        },
      },
    },
  };
  return (
    <>
    <div className="annual-head-stats-dashboard-container">
      <div className="annual-head-stats-dashboard-wrapper">
        <div className="annual-head-stats-top-cards-row">
          <div
            className={`annual-head-stats-balance-card ${isLoaded ? "annual-head-stats-slide-in-left" : ""}`}
          >
            <div className="annual-head-stats-card-header">
              <i className="fa fa-wallet annual-head-stats-card-icon"></i>
              <span className="annual-head-stats-card-title">
                Available Balance
              </span>
            </div>
            <div className="annual-head-stats-balance-amount">
              ₹{" "}
              <span className="annual-head-stats-animated-number">
                {animatedValues.availableBalance.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })}
              </span>
            </div>
            <div className="annual-head-stats-balance-subtitle">
              of actual income left to be allocated
            </div>
          </div>

          <div
            className={`annual-head-stats-income-card ${isLoaded ? "annual-head-stats-slide-in-up" : ""}`}
          >
            <div className="annual-head-stats-card-header">
              <div className="annual-head-stats-icon-badge income">
                <i className="fa fa-arrow-up" style={{ fontSize: "16px" }}></i>
              </div>
              <span className="annual-head-stats-card-title">Total Income</span>
            </div>
            <div className="annual-head-stats-income-amount">
              ₹{" "}
              <span className="annual-head-stats-animated-number">
                {animatedValues.totalIncome.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })}
              </span>
            </div>
            <div className="annual-head-stats-previous-balance">
              <span>Previous Balance</span>
              <span>₹ 500.00</span>
            </div>
          </div>

          <div
            className={`annual-head-stats-spending-card ${isLoaded ? "annual-head-stats-slide-in-up" : ""}`}
          >
            <div className="annual-head-stats-card-header">
              <div className="annual-head-stats-icon-badge spending">
                <i className="fa fa-shopping-bag" style={{ fontSize: "16px" }}></i>
              </div>
              <span className="annual-head-stats-card-title">
                Total Spending
              </span>
            </div>
            <div className="annual-head-stats-spending-amount">
              ₹{" "}
              <span className="annual-head-stats-animated-number">
                {animatedValues.totalSpending.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                })}
              </span>
            </div>
            <div className="annual-head-stats-spending-subtitle">
              (Expenses + Bills + Debts + Savings)
            </div>
          </div>

          <div
            className={`annual-head-stats-rate-card ${isLoaded ? "annual-head-stats-slide-in-right" : ""}`}
          >
            <div className="annual-head-stats-rate-header">
              <div className="annual-head-stats-icon-badge rate" style={{ marginBottom: "10px" }}>
                <i className="fa fa-bar-chart" style={{ fontSize: "16px" }}></i>
              </div>
              <span className="annual-head-stats-rate-title">
                Spending & Saving Rate based on
              </span>
              <span className="annual-head-stats-rate-subtitle">
                % allocated to Savings
              </span>
            </div>
            <div className="annual-head-stats-rate-content">
              <div className="annual-head-stats-spending-rate">
                <span className="annual-head-stats-rate-label">
                  You are spending
                </span>
                <span className="annual-head-stats-spending-percentage">
                  {animatedValues.spendingRate}%
                </span>
                <span className="annual-head-stats-rate-desc">
                  of your income
                </span>
              </div>
              <div className="annual-head-stats-saving-rate">
                <span className="annual-head-stats-rate-label">
                  You are saving
                </span>
                <span className="annual-head-stats-saving-percentage">
                  {animatedValues.savingRate}%
                </span>
                <span className="annual-head-stats-rate-desc">
                  of your income
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="annual-head-stats-bottom-cards-row">
          <div
            className={`annual-head-stats-status-card income-under ${isLoaded ? "annual-head-stats-fade-in-bottom" : ""}`}
          >
            <div className="annual-head-stats-status-header">
              <i
                className="fa fa-arrow-down annual-head-stats-status-icon annual-head-stats-down-icon"
                style={{ display: "flex" }}
              ></i>
              <span className="annual-head-stats-status-title">
                Income under expected
              </span>
              <span className="annual-head-stats-status-amount">
                ₹ {(remainingSummary?.Income ?? "").toString()}
              </span>
            </div>
            <div className="annual-head-stats-status-detail">
              <i className="fa fa-play annual-head-stats-detail-icon"></i>
              <span>Actual Amount Left</span>
              <span>₹ {(remainingSummary?.AmountLeft ?? "").toString()}</span>
            </div>
          </div>

          <div
            className={`annual-head-stats-status-card annual-head-stats-expenses-budget ${isLoaded ? "annual-head-stats-fade-in-bottom" : ""}`}
          >
            <div className="annual-head-stats-status-header">
              <i
                className="fa fa-arrow-up annual-head-stats-status-icon annual-head-stats-up-icon"
                style={{ display: "flex" }}
              ></i>
              <span className="annual-head-stats-status-title">
                Expenses In Budget
              </span>
              <span className="annual-head-stats-status-amount">
                ₹ {(remainingSummary?.Expenses ?? "").toString()}
              </span>
            </div>
            <div className="annual-head-stats-status-detail">
              <i className="fa fa-play annual-head-stats-detail-icon"></i>
              <span>Available Balance</span>
              <span>₹ {(remainingSummary?.AmountLeft ?? "").toString()}</span>
            </div>
          </div>

          <div
            className={`annual-head-stats-status-card annual-head-stats-bills-budget ${isLoaded ? "annual-head-stats-fade-in-bottom" : ""}`}
          >
            <div className="annual-head-stats-status-header">
              <i
                className="fa fa-arrow-up annual-head-stats-status-icon annual-head-stats-up-icon"
                style={{ display: "flex" }}
              ></i>
              <span className="annual-head-stats-status-title">
                Bills In Budget
              </span>
              <span className="annual-head-stats-status-amount">
                ₹ {(remainingSummary?.Bills ?? "").toString()}
              </span>
            </div>
            <div className="annual-head-stats-status-detail">
              <i className="fa fa-play annual-head-stats-detail-icon"></i>
              <span>Amounts that are not allocated to the next month</span>
              <span>₹ -</span>
            </div>
          </div>

          <div
            className={`annual-head-stats-status-card annual-head-stats-debts-unpaid ${isLoaded ? "annual-head-stats-fade-in-bottom" : ""}`}
          >
            <div className="annual-head-stats-status-header">
              <i
                className="fa fa-arrow-down annual-head-stats-status-icon annual-head-stats-down-icon"
                style={{ display: "flex" }}
              ></i>
              <span className="annual-head-stats-status-title">
                Debts Unpaid
              </span>
              <span className="annual-head-stats-status-amount">
                ₹ {(remainingSummary?.Debts ?? "").toString()}
              </span>
            </div>
          </div>

          <div
            className={`annual-head-stats-status-card annual-head-stats-savings-goal ${isLoaded ? "annual-head-stats-fade-in-bottom" : ""}`}
          >
            <div className="annual-head-stats-status-header">
              <i
                className="fa fa-arrow-down annual-head-stats-status-icon annual-head-stats-down-icon"
                style={{ display: "flex" }}
              ></i>
              <span className="annual-head-stats-status-title">
                Savings Under Goal
              </span>
              <span className="annual-head-stats-status-amount">
                ₹ {(remainingSummary?.Savings ?? "").toString()}
              </span>
            </div>
          </div>
        </div> */}
      </div>

      <div style={{
         border: "1px solid rgba(226, 232, 240, 0.8)",
         borderRadius: '16px',
         boxShadow: "none",
         marginTop: '20px',
         backgroundColor: "#ffffff",
         }}>
          <h2
                style={{
                  padding:"15px",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#1F2937",
                  margin: "0 0 16px 0",
                }}
              >
                Expense Growth
              </h2>
        <Chart
                    options={growthChartOptions}
                    series={growthChartSeries}
                    type="line"
                    height={320}
                  />
      </div>
    </div>
    </>
  );
}

export default AnnualHeadStats;
